import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { StorageBin, StorageBinCreate, StorageBinFilter } from '../data/storageBin';

export function createStorageBinService(client: AxiosInstance) {
  return createCrudService<StorageBin, StorageBinCreate, StorageBinFilter>(
    client,
    '/master-data/StorageBin',
    'id',
  );
}

export type StorageBinService = CrudService<StorageBin, StorageBinCreate, StorageBinFilter>;
